(function () {
  const NAV_ID = "menu-nav";
  const SECTION_SELECTOR = ".menu-category[id^='cat-']";

  function getHeaderVisibleBottom() {
    const sticky = document.querySelector("sticky-header");
    const header = sticky || document.querySelector("header");
    if (!header) return 0;

    const rect = header.getBoundingClientRect();
    return Math.max(0, Math.ceil(rect.bottom));
  }

  function setOffsetVar() {
    const offset = getHeaderVisibleBottom();
    document.documentElement.style.setProperty("--menu-header-offset", offset + "px");
    return offset;
  }

  function buildNav() {
    const nav = document.getElementById(NAV_ID);
    if (!nav) return;

    const sections = Array.from(document.querySelectorAll(SECTION_SELECTOR));
    if (!sections.length) return;

    setOffsetVar();
    nav.innerHTML = "";

    const frag = document.createDocumentFragment();

    sections.forEach((sec, idx) => {
      const label =
        sec.querySelector(".menu-category__name p")?.textContent?.trim() ||
        sec.getAttribute("id") ||
        `Category ${idx + 1}`;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "menu-nav__btn";
      btn.textContent = label;
      btn.dataset.target = sec.id;

      frag.appendChild(btn);
    });

    nav.appendChild(frag);

    const buttons = Array.from(nav.querySelectorAll(".menu-nav__btn"));
    const byId = new Map(buttons.map((b) => [b.dataset.target, b]));
    let currentActiveId = null;

    function setActive(id) {
      if (!id || id === currentActiveId) return;
      currentActiveId = id;

      buttons.forEach((b) => b.classList.toggle("is-active", b.dataset.target === id));

      const activeBtn = byId.get(id);
      if (!activeBtn) return;

      const navRect = nav.getBoundingClientRect();
      const btnRect = activeBtn.getBoundingClientRect();
      const outOfView = btnRect.left < navRect.left || btnRect.right > navRect.right;

      if (outOfView) {
        // Scroll only within the nav bar horizontally — never move the page vertically
        const btnCenter = activeBtn.offsetLeft + activeBtn.offsetWidth / 2;
        nav.scrollTo({ left: btnCenter - nav.offsetWidth / 2, behavior: "smooth" });
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = document.getElementById(btn.dataset.target);
        if (!target) return;

        const headerOffset = setOffsetVar();
        const extra = 14;
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - extra;

        window.scrollTo({ top, behavior: "smooth" });
        setActive(btn.dataset.target);
      });
    });

    setActive(sections[0].id);

    let observer = null;

    function setupObserver() {
      if (observer) observer.disconnect();

      const headerOffset = setOffsetVar();

      observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((e) => e.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!visible) return;
          setActive(visible.target.id);
        },
        {
          root: null,
          threshold: [0.25, 0.4, 0.55],
          rootMargin: `-${headerOffset + 80}px 0px -60% 0px`
        }
      );

      sections.forEach((sec) => observer.observe(sec));
    }

    setupObserver();

    window.addEventListener(
      "scroll",
      () => {
        setOffsetVar();
      },
      { passive: true }
    );

    let t = null;
    window.addEventListener("resize", () => {
      clearTimeout(t);
      t = setTimeout(setupObserver, 150);
    });

    const topBtn = document.getElementById("menu-topbtn");
    if (topBtn) {
      function toggleTopBtn() {
        topBtn.classList.toggle("is-show", window.scrollY > 600);
      }

      toggleTopBtn();
      window.addEventListener("scroll", toggleTopBtn, { passive: true });

      topBtn.addEventListener("click", () => {
        const first = document.querySelector(".menu-category[id^='cat-']");
        if (!first) return;

        const offset = getHeaderVisibleBottom() + 16;
        const top = first.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top, behavior: "smooth" });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", buildNav);
})();
